











import Vue from "vue";
import { EventDocumentation } from "@/api";
import { Prop } from "vue/types/options";

export default Vue.extend({
  props: {
    events: Array as Prop<EventDocumentation[]>
  },
  computed: {
    headers(): string[] {
      return ["Event", "Description"];
    }
  }
});
